/** Navigation state for the whole app. The playback clock remains separate. */
export type SessionMode = 'results' | 'live-follow' | 'live-review' | 'results-review' | 'history-final' | 'history-replay' | 'demo-replay';

export interface SessionTimelineState {
  sessionKey: string;
  mode: SessionMode;
}

export type SessionTimelineAction =
  | { type: 'open-results' }
  | { type: 'open-live'; sessionKey: string }
  | { type: 'open-history'; sessionKey: string }
  | { type: 'open-demo'; sessionKey: string }
  | { type: 'play' }
  | { type: 'seek' }
  | { type: 'return-live' }
  | { type: 'finish-history' }
  | { type: 'return-results' };

export function createSessionTimeline(sessionKey = 'loading'): SessionTimelineState {
  return { sessionKey, mode: 'results' };
}

export function reduceSessionTimeline(state: SessionTimelineState, action: SessionTimelineAction): SessionTimelineState {
  switch (action.type) {
    case 'open-results': return { sessionKey: 'results', mode: 'results' };
    case 'open-live': return { sessionKey: action.sessionKey, mode: 'live-follow' };
    case 'open-history': return { sessionKey: action.sessionKey, mode: 'history-final' };
    case 'open-demo': return { sessionKey: action.sessionKey, mode: 'demo-replay' };
    case 'play': return state.mode === 'history-final' ? { ...state, mode: 'history-replay' } : state;
    case 'seek': return { ...state,
      mode: state.mode === 'live-follow' ? 'live-review' : state.mode === 'results' ? 'results-review' : state.mode === 'history-final' ? 'history-replay' : state.mode };
    case 'return-live': return { ...state, mode: 'live-follow' };
    case 'finish-history': return state.mode === 'history-replay' ? { ...state, mode: 'history-final' } : state;
    case 'return-results': return { sessionKey: 'results', mode: 'results' };
  }
}
